export enum AssessmentStatus{
    NotStarted,
    InProgress,
    Completed
}